import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, switchMap} from 'rxjs';
import * as fromGraphql from './feedback-category.graphql';
import * as fromActions from './feedback-category.actions';
import {Store} from '@ngrx/store';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from '../../reducers';
import {Apollo} from 'apollo-angular';


@Injectable()
export class FeedbackCategoryEffects {
  createFeedbackCategory$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createFeedbackCategory),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_FEEDBACK_CATEGORY,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertFeedbackCategory({ feedbackCategory: result?.data }));
              this.notificationService.successMessage('Created Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateFeedbackCategory$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editFeedbackCategory),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_FEEDBACK_CATEGORY,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertFeedbackCategory({ feedbackCategory: result?.data }));
              this.notificationService.successMessage('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteFeedbackCategory$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeFeedbackCategory),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_FEEDBACK_CATEGORY,
        variables: {
          categoryUniqueId: action?.categoryUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteFeedbackCategory({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getAllFeedbackCategories$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllFeedbackCategories),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_FEEDBACK_CATEGORIES,
        fetchPolicy: 'network-only'
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service categories'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadFeedbackCategorys({ feedbackCategorys: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
